import { ExternalLink } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { ResultTable } from './ResultTable';
import type { HostInfoResult } from '@/api/ipezby/types';

interface ResultsSectionProps {
  data: HostInfoResult | null;
  showComments: boolean;
  onHostClick: (host: string) => void;
}

export function ResultsSection({
  data,
  showComments,
  onHostClick,
}: ResultsSectionProps) {
  if (!data) return null;

  return (
    <div className="space-y-4">
      {/* Port Scan Link */}
      <Card>
        <CardContent className="p-4">
          <a
            href={`https://z.ez.by/?host=${encodeURIComponent(data.host)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-primary hover:underline"
          >
            <ExternalLink className="w-4 h-4" />
            Port Scan (z.ez.by)
          </a>
        </CardContent>
      </Card>

      {/* Scan Information (raw HTML from backend) */}
      {data.whois.scan && data.whois.scan.trim() !== '' && (
        <Card>
          <CardContent className="p-4">
            <h3 className="font-semibold mb-2">Scan Information</h3>
            <div
              className="text-sm [&_a]:text-primary [&_a]:hover:underline"
              dangerouslySetInnerHTML={{ __html: data.whois.scan }}
            />
          </CardContent>
        </Card>
      )}

      {/* WHOIS Information */}
      <ResultTable
        title="WHOIS Information"
        content={data.whois.info}
        showComments={showComments}
        onHostClick={onHostClick}
      />

      {/* DNS/PTR Records */}
      {data.dnsRecords.map((record) => (
        <ResultTable
          key={record.type}
          title={`${record.type} Records`}
          content={record.info}
          showComments={showComments}
          onHostClick={onHostClick}
        />
      ))}
    </div>
  );
}
